export default  [
  ["nostr.build", "https://nostr.build/api/v2/nip96/upload"],
  ["nostrmedia.com", "https://nostrmedia.com/upload"],
  ["nostrcheck.me", "https://nostrcheck.me/api/v2/media"],
  ["void.cat", "https://void.cat/n96"],
];
